const pineapplePulpData = {
  hero_section: {
    title: "Premium Pineapple Pulp Collection",
    description: "100% Natural • No Preservatives • Tropical Freshness",
    src: "videos/pineapple-processing.webm",
  },
  description: {
    title: "Premium Pineapple Pulp Collection",
    main_description:
      "Discover our range of 100% natural pineapple pulp, crafted from the finest pineapple varieties to preserve the authentic tropical flavors and natural sweetness.",
    segment_description:
      "Perfect for beverages, desserts, and food processing applications.",
    variety_description:
      "Available in various grades and pack sizes to suit every commercial need.",
  },
  main_product: {
    title: "Premium Pineapple Pulp",
    description: "Our pineapple pulp collection delivers the perfect balance of sweetness and tang. Rich in enzymes and tropical flavor, our pineapple pulps are ideal for beverages, desserts, and food processing applications.",
    image: "New-Images/Pineapple.png",
    mainFeatures: [
      "Rich in natural enzymes",
      "Perfect sweet-tart balance", 
      "Tropical flavor profile",
      "Ideal for beverages and desserts",
      "Premium quality processing",
      "Consistent taste and texture"
    ],
    nutrition: {
      servingSize: "100g",
      calories: "82",
      fat: "0g",
      carbs: "18g (Sugar: 18g, Added: 10g)",
      fiber: "3g",
      protein: "0g",
      sodium: "0mg",
      potassium: "129mg"
    }
  },
  products: [
    {
      id: "1",
      name: "Sweet Pineapple Pulp",
      image: "New-Images/Pineapple.png",
      features: [
        "Premium sweet variety",
        "Natural sweetness",
        "Tropical flavor",
        "Perfect for beverages"
      ],
      meta: {
        weight: "Customized pack sizes"
      }
    },
    {
      id: "2",
      name: "Tangy Pineapple Pulp",
      image: "New-Images/Pineapple.png",
      features: [
        "Balanced acidity",
        "Refreshing taste",
        "High vitamin C",
        "Ideal for desserts"
      ],
      meta: {
        weight: "Customized pack sizes"
      }
    },
    {
      id: "3",
      name: "Mixed Pineapple Pulp",
      image: "New-Images/Pineapple.png",
      features: [
        "Blend of varieties",
        "Balanced flavor",
        "Cost-effective",
        "Versatile applications"
      ],
      meta: {
        weight: "Customized pack sizes"
      }
    }
  ],

  text_section: {
    title: "Pineapple Pulp Excellence",
    description: "Our pineapple pulp is processed from the finest handpicked pineapples using advanced processing techniques. We maintain strict quality control to ensure consistent taste, texture, and nutritional value in every batch.",
  },
  
  feature_text_section: {
    title: "Perfect for Food Industry",
    subline: "From beverages to desserts – authentic pineapple flavor in every application!",
    description:
      "Ideal for juice manufacturers, ice cream producers, confectionery makers, and food service providers who demand consistent quality and authentic tropical taste.",
  },
  
  feature_cards_info_card: [
    {
      id: 1,
      image: "beverage-applications.webp",
      title: "Beverage Applications",
      description:
        "Perfect for pineapple juices, smoothies, and tropical drink mixes with consistent flavor and color.",
    },
    {
      id: 2,
      image: "dessert-applications.webp",
      title: "Dessert Applications",
      description:
        "Ideal for ice creams, yogurts, cakes, and confectionery products requiring authentic pineapple taste.",
    },
    {
      id: 3,
      image: "food-service-applications.webp",
      title: "Food Service",
      description:
        "Excellent for restaurants, cafes, and catering services looking for premium pineapple ingredients.",
    },
  ],
  
  overlay_card: [
    {
      id: 1,
      key: "Natural Processing",
      image: "natural-processing.webp",
      title: "Natural Processing",
      description:
        "No artificial preservatives, colors, or additives—just pure, natural pineapple goodness",
    },
    {
      id: 2,
      key: "Quality Assurance",
      image: "quality-assurance.webp",
      title: "Quality Assurance",
      description:
        "Rigorous testing and quality control at every stage ensures premium standards",
    },
    {
      id: 3,
      key: "Consistent Supply",
      image: "consistent-supply.webp",
      title: "Consistent Supply",
      description:
        "Reliable production capacity and supply chain for your business needs",
    },
    {
      id: 4,
      key: "Versatile Applications",
      image: "versatile-applications.webp",
      title: "Versatile Applications",
      description:
        "Suitable for beverages, desserts, confectionery, and food service applications",
    },
  ],
  
  why_choose_section: {
    title: "Why Choose Our Pineapple Pulp",
    description: "Discover the perfect blend of quality, consistency, and authentic flavors that make our pineapple pulp the preferred choice for food manufacturers worldwide.",
  },
};

export default pineapplePulpData;
